<script lang="ts">
	import { clickOutside } from './../../../../../helpers/index.js';
	import { _ } from 'svelte-i18n'
  import { createEventDispatcher } from 'svelte'
  import type { IComment } from '../../../../../types/index.js'
  import { currentReplyCommentId } from './../ReplyInput/store/index.js'
  import { info_client, is_show_copy_telegram_id_tooltip } from '../../../../stores'

  import ImagePopup from '../../../ImagePopup.svelte'
  import ReplyInput from '../ReplyInput/ReplyInput.svelte'
  import CommentLike from './components/CommentLike.svelte'
  import CommentActions from './components/CommentActions.svelte'
  import BurgerIcon from '../../../../../../public/svg/burger.svg'
  import DateComponent from '../../../DateComponent.svelte'
  import { api } from '../../../../../helpers/index.js';
  import { getBaseApiUrl } from '../../../../../api/base.js';

  const dispatch = createEventDispatcher<{
    'created-comment': { data: IComment },
    'scroll-to-children': { comment: IComment },
    'update': { data: null | IComment },
    'report': { comment: IComment },
    'fixed-comment': void
  }>()

  const baseUrl = getBaseApiUrl();

  let isMobile: boolean

  $: isMobile = Math.min(window.screen.width, window.screen.height) < 576

  export let comment: IComment
  export let id_publicate: string
  export let isChild: boolean = false
  export let index: number
  export let disable_comments: boolean
  export let sortItem: string
  export let isLastComment: boolean
  
  let showModalPictere = false
  let showMessage = false
  let isShowReplyInput = false
  let isShowCuratorCard = false

  let currentShowImage = {
    index: 0,
    image: '',
  };

  let curatorCardInfo = null 

  const replyHandler = (): void => {
    isShowReplyInput = !isShowReplyInput
    currentReplyCommentId.set(comment.pk)
  }

  const createdComment = (event: CustomEvent<{ comment: IComment }>): void => {
    isShowReplyInput = false

    dispatch('created-comment', { data: event.detail.comment })
  }

  const getMobileClass = (): string => {
    if (!isMobile) {
      return ''
    }

    return comment.comment_images.length > 4
      ? 'three-span'
      : 'two-span'
  }

  const changeImage = (event: CustomEvent<{ type: 'prev' | 'next' }>): void => {
    const type = event.detail.type

    currentShowImage.index = type === 'next'
      ? currentShowImage.index += 1
      : currentShowImage.index -= 1

    currentShowImage.image = comment.comment_images[currentShowImage.index].image
  }

  const updateComment = (event: CustomEvent<{ data: null | IComment }>): void => {
    dispatch('update', { data: event.detail.data })
  }

  const reportComment = () => {
    dispatch('report')
  }

  const fixedComment = () => {
    dispatch('fixed-comment')
  }

  const getUserInfoForCuratorCard = async (userId) => {
    const response = await api(`${baseUrl}api/v1/content/get-user-info-for-content-popup/${userId}/`)
    const data = response.json()

    return data
  }

  const curatorCardHandler = async () => {
    if (!$info_client.is_staff || comment.jwt_client.is_staff) {
      return;
    }

    curatorCardInfo = await getUserInfoForCuratorCard(comment.jwt_client.user_id)

    isShowCuratorCard = !isShowCuratorCard
  }

  const openPhtUrl = (url) => {
    window.open(url, '_blank');
  }

  const copyTelegramId = async () => {
    try {
      await navigator.clipboard.writeText(curatorCardInfo.telegram_id);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }

    is_show_copy_telegram_id_tooltip.set(true);

    setTimeout(() => is_show_copy_telegram_id_tooltip.set(false), 3000);
  }
</script>

<div class='main' class:child={isChild} class:first-child={isChild && !index}>
  <div class='main__info'>
    <div class="wrapper">
      <div class='main__info_client'>
        {#if comment.jwt_client.avatar_url === ''}
          <img class='image' src="/static/avatar.webp" alt="" width='34' height='34'>
        {:else}
          <img class='image' src={comment.jwt_client.avatar_url} alt="" width='34' height='34'>
        {/if}

        <div class='block_name_user'>
          {#if !comment.abstract_removed}
            <div on:click={curatorCardHandler}>
              <span 
                class='name text-grey text-bold' 
                style:cursor={$info_client.is_staff ? 'pointer' : 'initial'}
              >
                {comment.jwt_client.first_name}
              </span>

              <span 
                class='name text-grey text-bold' 
                style="padding-left: 0"
                style:cursor={$info_client.is_staff ? 'pointer' : 'initial'}
              >
                {comment.jwt_client.last_name}
              </span>

              {#if isShowCuratorCard}
                <div 
                  class="curator-card"
                  style:top={isLastComment ? '-210px' : 'initial'}
                  use:clickOutside
                  on:click_outside={() => isShowCuratorCard = !isShowCuratorCard}
                >
                  <div class="curator-card-header">
                    <div 
                      class="curator-card-image" 
                      style:background={`url("${comment.jwt_client.avatar_url}") no-repeat center/cover`}
                    />
                    <div class="curator-card-title">
                      {`${curatorCardInfo.first_name} ${curatorCardInfo.last_name}`}
                    </div>
                  </div>
                  
                  <div class="curator-card-body">
                    {#if curatorCardInfo.physical_training}
                      <div class="curator-card-item">
                        <i class="icon-ph_life_only_icon_without_bg_small_bold" />
                        <div>Участник Физикл ИПТ</div>
                      </div>
                    {/if}

                    {#if curatorCardInfo.curator}
                      <div class="curator-card-item">
                        <div>Куратор:&nbsp;</div>
                        <div>{curatorCardInfo.curator.substring(0, curatorCardInfo.curator.indexOf("["))}</div>
                      </div>
                    {/if}

                    {#if curatorCardInfo.fat_pecent && curatorCardInfo.weight}
                      <div class="curator-card-item">
                        <div>Параметры:&nbsp;</div>
                        <div>{curatorCardInfo.fat_pecent}% жира, {curatorCardInfo.weight.toFixed(1)} кг</div>
                      </div>
                    {/if}
                  </div>

                  <div class="curator-card-footer">
                    <svg 
                      width="22" 
                      height="20" 
                      viewBox="0 0 22 20" 
                      fill="none" 
                      xmlns="http://www.w3.org/2000/svg"
                      on:click|stopPropagation={() => openPhtUrl(`${baseUrl}${curatorCardInfo.link_persone_theme.substring(1)}`)}
                    >
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M4.9999 1.6001C3.01168 1.6001 1.3999 3.21187 1.3999 5.2001V12.4001C1.3999 14.3883 3.01168 16.0001 4.9999 16.0001H20.5999V5.2001C20.5999 3.21187 18.9881 1.6001 16.9999 1.6001H4.9999ZM6.19988 10C6.86262 10 7.39988 9.46274 7.39988 8.8C7.39988 8.13726 6.86262 7.6 6.19988 7.6C5.53714 7.6 4.99988 8.13726 4.99988 8.8C4.99988 9.46274 5.53714 10 6.19988 10ZM12.1999 8.8C12.1999 9.46274 11.6626 10 10.9999 10C10.3371 10 9.79988 9.46274 9.79988 8.8C9.79988 8.13726 10.3371 7.6 10.9999 7.6C11.6626 7.6 12.1999 8.13726 12.1999 8.8ZM15.7999 10C16.4626 10 16.9999 9.46274 16.9999 8.8C16.9999 8.13726 16.4626 7.6 15.7999 7.6C15.1371 7.6 14.5999 8.13726 14.5999 8.8C14.5999 9.46274 15.1371 10 15.7999 10Z" fill="#2B50ED"/>
                      <path d="M20.5999 16H14.5999L20.5999 19.6L20.5999 16Z" fill="#2B50ED"/>
                    </svg>         
                    
                    <svg 
                      width="18" 
                      height="20" 
                      viewBox="0 0 18 20" 
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      on:click|stopPropagation={() => openPhtUrl(`${baseUrl}${curatorCardInfo.link_persone_calk.substring(1)}`)}
                    >
                      <mask id="path-1-inside-1_9284_154867" fill="white">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.6 0.399902C1.61177 0.399902 0 2.01168 0 3.9999V15.9999C0 17.9881 1.61178 19.5999 3.6 19.5999H14.4C16.3882 19.5999 18 17.9881 18 15.9999V6.4H18V5.2H18V3.9999C18 2.01168 16.3882 0.399902 14.4 0.399902H3.6ZM18 5.2H2.44141e-05V6.4H18V5.2ZM2.40002 10.6C2.40002 9.60589 3.20591 8.8 4.20002 8.8C5.19414 8.8 6.00002 9.60589 6.00002 10.6C6.00002 11.5941 5.19414 12.4 4.20002 12.4C3.20591 12.4 2.40002 11.5941 2.40002 10.6ZM4.20002 13.6C3.20591 13.6 2.40002 14.4059 2.40002 15.4C2.40002 16.3941 3.20591 17.2 4.20002 17.2C5.19414 17.2 6.00002 16.3941 6.00002 15.4C6.00002 14.4059 5.19414 13.6 4.20002 13.6ZM7.20002 10.6C7.20002 9.60589 8.00591 8.8 9.00002 8.8C9.99414 8.8 10.8 9.60589 10.8 10.6C10.8 11.5941 9.99414 12.4 9.00002 12.4C8.00591 12.4 7.20002 11.5941 7.20002 10.6ZM13.8 8.8C12.8059 8.8 12 9.60589 12 10.6C12 11.5941 12.8059 12.4 13.8 12.4C14.7941 12.4 15.6 11.5941 15.6 10.6C15.6 9.60589 14.7941 8.8 13.8 8.8ZM7.20002 15.4C7.20002 14.4059 8.00591 13.6 9.00002 13.6C9.99414 13.6 10.8 14.4059 10.8 15.4C10.8 16.3941 9.99414 17.2 9.00002 17.2C8.00591 17.2 7.20002 16.3941 7.20002 15.4ZM13.8 13.6C12.8059 13.6 12 14.4059 12 15.4C12 16.3941 12.8059 17.2 13.8 17.2C14.7941 17.2 15.6 16.3941 15.6 15.4C15.6 14.4059 14.7941 13.6 13.8 13.6Z"/>
                      </mask>
                      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.6 0.399902C1.61177 0.399902 0 2.01168 0 3.9999V15.9999C0 17.9881 1.61178 19.5999 3.6 19.5999H14.4C16.3882 19.5999 18 17.9881 18 15.9999V6.4H18V5.2H18V3.9999C18 2.01168 16.3882 0.399902 14.4 0.399902H3.6ZM18 5.2H2.44141e-05V6.4H18V5.2ZM2.40002 10.6C2.40002 9.60589 3.20591 8.8 4.20002 8.8C5.19414 8.8 6.00002 9.60589 6.00002 10.6C6.00002 11.5941 5.19414 12.4 4.20002 12.4C3.20591 12.4 2.40002 11.5941 2.40002 10.6ZM4.20002 13.6C3.20591 13.6 2.40002 14.4059 2.40002 15.4C2.40002 16.3941 3.20591 17.2 4.20002 17.2C5.19414 17.2 6.00002 16.3941 6.00002 15.4C6.00002 14.4059 5.19414 13.6 4.20002 13.6ZM7.20002 10.6C7.20002 9.60589 8.00591 8.8 9.00002 8.8C9.99414 8.8 10.8 9.60589 10.8 10.6C10.8 11.5941 9.99414 12.4 9.00002 12.4C8.00591 12.4 7.20002 11.5941 7.20002 10.6ZM13.8 8.8C12.8059 8.8 12 9.60589 12 10.6C12 11.5941 12.8059 12.4 13.8 12.4C14.7941 12.4 15.6 11.5941 15.6 10.6C15.6 9.60589 14.7941 8.8 13.8 8.8ZM7.20002 15.4C7.20002 14.4059 8.00591 13.6 9.00002 13.6C9.99414 13.6 10.8 14.4059 10.8 15.4C10.8 16.3941 9.99414 17.2 9.00002 17.2C8.00591 17.2 7.20002 16.3941 7.20002 15.4ZM13.8 13.6C12.8059 13.6 12 14.4059 12 15.4C12 16.3941 12.8059 17.2 13.8 17.2C14.7941 17.2 15.6 16.3941 15.6 15.4C15.6 14.4059 14.7941 13.6 13.8 13.6Z" fill="#2B50ED"/>
                      <path d="M18 6.4V8.8H20.4V6.4H18ZM18 5.2H20.4V2.8H18V5.2ZM2.44141e-05 5.2V2.8H-2.39998V5.2H2.44141e-05ZM2.44141e-05 6.4H-2.39998V8.8H2.44141e-05V6.4ZM2.4 3.9999C2.4 3.33716 2.93726 2.7999 3.6 2.7999V-2.0001C0.286293 -2.0001 -2.4 0.68619 -2.4 3.9999H2.4ZM2.4 15.9999V3.9999H-2.4V15.9999H2.4ZM3.6 17.1999C2.93726 17.1999 2.4 16.6626 2.4 15.9999H-2.4C-2.4 19.3136 0.286292 21.9999 3.6 21.9999V17.1999ZM14.4 17.1999H3.6V21.9999H14.4V17.1999ZM15.6 15.9999C15.6 16.6626 15.0627 17.1999 14.4 17.1999V21.9999C17.7137 21.9999 20.4 19.3136 20.4 15.9999H15.6ZM15.6 6.4V15.9999H20.4V6.4H15.6ZM18 8.8H18V4H18V8.8ZM20.4 6.4V5.2H15.6V6.4H20.4ZM18 2.8H18V7.6H18V2.8ZM15.6 3.9999V5.2H20.4V3.9999H15.6ZM14.4 2.7999C15.0627 2.7999 15.6 3.33716 15.6 3.9999H20.4C20.4 0.686193 17.7137 -2.0001 14.4 -2.0001V2.7999ZM3.6 2.7999H14.4V-2.0001H3.6V2.7999ZM18 2.8H2.44141e-05V7.6H18V2.8ZM-2.39998 5.2V6.4H2.40002V5.2H-2.39998ZM2.44141e-05 8.8H18V4H2.44141e-05V8.8ZM15.6 5.2V6.4H20.4V5.2H15.6ZM4.20002 6.4C1.88043 6.4 2.43187e-05 8.28041 2.43187e-05 10.6H4.80002C4.80002 10.9314 4.5314 11.2 4.20002 11.2V6.4ZM8.40002 10.6C8.40002 8.28041 6.51962 6.4 4.20002 6.4V11.2C3.86865 11.2 3.60002 10.9314 3.60002 10.6H8.40002ZM4.20002 14.8C6.51962 14.8 8.40002 12.9196 8.40002 10.6H3.60002C3.60002 10.2686 3.86865 10 4.20002 10V14.8ZM2.43187e-05 10.6C2.43187e-05 12.9196 1.88043 14.8 4.20002 14.8V10C4.53139 10 4.80002 10.2686 4.80002 10.6H2.43187e-05ZM4.80002 15.4C4.80002 15.7314 4.5314 16 4.20002 16V11.2C1.88043 11.2 2.43187e-05 13.0804 2.43187e-05 15.4H4.80002ZM4.20002 14.8C4.5314 14.8 4.80002 15.0686 4.80002 15.4H2.43187e-05C2.43187e-05 17.7196 1.88043 19.6 4.20002 19.6V14.8ZM3.60002 15.4C3.60002 15.0686 3.86865 14.8 4.20002 14.8V19.6C6.51962 19.6 8.40002 17.7196 8.40002 15.4H3.60002ZM4.20002 16C3.86865 16 3.60002 15.7314 3.60002 15.4H8.40002C8.40002 13.0804 6.51962 11.2 4.20002 11.2V16ZM9.00002 6.4C6.68043 6.4 4.80002 8.28041 4.80002 10.6H9.60003C9.60003 10.9314 9.3314 11.2 9.00002 11.2V6.4ZM13.2 10.6C13.2 8.28041 11.3196 6.4 9.00002 6.4V11.2C8.66865 11.2 8.40002 10.9314 8.40002 10.6H13.2ZM9.00002 14.8C11.3196 14.8 13.2 12.9196 13.2 10.6H8.40002C8.40002 10.2686 8.66865 10 9.00002 10V14.8ZM4.80002 10.6C4.80002 12.9196 6.68043 14.8 9.00002 14.8V10C9.33139 10 9.60003 10.2686 9.60003 10.6H4.80002ZM14.4 10.6C14.4 10.9314 14.1314 11.2 13.8 11.2V6.4C11.4804 6.4 9.60003 8.28041 9.60003 10.6H14.4ZM13.8 10C14.1314 10 14.4 10.2686 14.4 10.6H9.60003C9.60003 12.9196 11.4804 14.8 13.8 14.8V10ZM13.2 10.6C13.2 10.2686 13.4687 10 13.8 10V14.8C16.1196 14.8 18 12.9196 18 10.6H13.2ZM13.8 11.2C13.4687 11.2 13.2 10.9314 13.2 10.6H18C18 8.28041 16.1196 6.4 13.8 6.4V11.2ZM9.00002 11.2C6.68043 11.2 4.80002 13.0804 4.80002 15.4H9.60003C9.60003 15.7314 9.3314 16 9.00002 16V11.2ZM13.2 15.4C13.2 13.0804 11.3196 11.2 9.00002 11.2V16C8.66865 16 8.40002 15.7314 8.40002 15.4H13.2ZM9.00002 19.6C11.3196 19.6 13.2 17.7196 13.2 15.4H8.40002C8.40002 15.0686 8.66865 14.8 9.00002 14.8V19.6ZM4.80002 15.4C4.80002 17.7196 6.68043 19.6 9.00002 19.6V14.8C9.3314 14.8 9.60003 15.0686 9.60003 15.4H4.80002ZM14.4 15.4C14.4 15.7314 14.1314 16 13.8 16V11.2C11.4804 11.2 9.60003 13.0804 9.60003 15.4H14.4ZM13.8 14.8C14.1314 14.8 14.4 15.0686 14.4 15.4H9.60003C9.60003 17.7196 11.4804 19.6 13.8 19.6V14.8ZM13.2 15.4C13.2 15.0686 13.4687 14.8 13.8 14.8V19.6C16.1196 19.6 18 17.7196 18 15.4H13.2ZM13.8 16C13.4687 16 13.2 15.7314 13.2 15.4H18C18 13.0804 16.1196 11.2 13.8 11.2V16Z" fill="#2B50ED" mask="url(#path-1-inside-1_9284_154867)"/>
                    </svg>

                    {#if curatorCardInfo.telegram_id && $info_client.moderator}
                      <svg 
                        width="24" 
                        height="24" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg"
                        on:click={copyTelegramId}
                      >
                        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16.64 8.8C16.49 10.38 15.84 14.22 15.51 15.99C15.37 16.74 15.09 16.99 14.83 17.02C14.25 17.07 13.81 16.64 13.25 16.27C12.37 15.69 11.87 15.33 11.02 14.77C10.03 14.12 10.67 13.76 11.24 13.18C11.39 13.03 13.95 10.7 14 10.49C14.0069 10.4582 14.006 10.4252 13.9973 10.3938C13.9886 10.3624 13.9724 10.3337 13.95 10.31C13.89 10.26 13.81 10.28 13.74 10.29C13.65 10.31 12.25 11.24 9.52 13.08C9.12 13.35 8.76 13.49 8.44 13.48C8.08 13.47 7.4 13.28 6.89 13.11C6.26 12.91 5.77 12.8 5.81 12.45C5.83 12.27 6.08 12.09 6.55 11.9C9.47 10.63 11.41 9.79 12.38 9.39C15.16 8.23 15.73 8.03 16.11 8.03C16.19 8.03 16.38 8.05 16.5 8.15C16.6 8.23 16.63 8.34 16.64 8.42C16.63 8.48 16.65 8.66 16.64 8.8Z" fill="url(#paint0_linear_9284_154880)"/>
                        <defs>
                        <linearGradient id="paint0_linear_9284_154880" x1="12" y1="2" x2="12" y2="22" gradientUnits="userSpaceOnUse">
                        <stop stop-color="#2AABEE"/>
                        <stop offset="1" stop-color="#229ED9"/>
                        </linearGradient>
                        </defs>
                      </svg>   
                    {/if}                   
                  </div>
                </div>
              {/if}
            </div>
          {:else}
            <span class="deleted-comment-text">
              {$_('commentDeletedByUser')}
            </span>
          {/if}

          {#if !comment.abstract_removed}
            {#if comment.jwt_client.is_staff}
              <div data-tooltip={$_('TeamPHT')}>
                <i class='text-grey icon-ph_life_only_icon_without_bg_small_bold'></i>
              </div>
            {/if}

            {#if comment.jwt_client.expert}
              <div class="flex ml-xs" data-tooltip={$_('experienced')}>
                <BurgerIcon />   
              </div>
            {/if}

            {#if comment.isFixed}
              <div class="ml-xs flex items-center justify-center">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.5187 3C11.5844 2.99988 11.6495 3.01272 11.7102 3.03777C11.771 3.06282 11.8262 3.0996 11.8727 3.146L16.8227 8.096C16.9164 8.18976 16.9691 8.31692 16.9691 8.4495C16.9691 8.58208 16.9164 8.70924 16.8227 8.803C16.3427 9.283 15.7507 9.391 15.3197 9.391C15.1427 9.391 14.9847 9.373 14.8597 9.352L11.7257 12.486C11.8082 12.8184 11.8617 13.1573 11.8857 13.499C11.9317 14.201 11.8537 15.186 11.1657 15.874C11.0719 15.9677 10.9448 16.0204 10.8122 16.0204C10.6796 16.0204 10.5524 15.9677 10.4587 15.874L7.62968 13.046L4.44768 16.228C4.25268 16.423 3.22868 17.13 3.03368 16.935C2.83868 16.74 3.54568 15.715 3.74068 15.521L6.92268 12.339L4.09468 9.51C4.00094 9.41624 3.94828 9.28908 3.94828 9.1565C3.94828 9.02392 4.00094 8.89676 4.09468 8.803C4.78268 8.115 5.76768 8.036 6.46968 8.083C6.81134 8.10694 7.15027 8.16047 7.48268 8.243L10.6167 5.11C10.5905 4.95772 10.5771 4.80351 10.5767 4.649C10.5767 4.219 10.6847 3.627 11.1657 3.146C11.2594 3.05253 11.3863 3.00003 11.5187 3Z" fill="#BDBFC4"/>
                </svg>       
              </div>
            {/if}       
          {/if}
        </div>
      </div>

      {#if !comment.abstract_removed}
        <div class="flex items-center">
          {#if comment.bad_reported && $info_client.moderator}
            <div data-tooltip="На этот комментарий есть жалоба">
              <i class="icon-warning-fill mr-md" />
            </div>
          {/if}
        
          <CommentActions
            {sortItem}
            {id_publicate}
            {comment}
            {isChild}
            on:update={updateComment}
            on:report={reportComment}
            on:fixed-comment={fixedComment}
          />
        </div>
      {/if}
    </div>
  </div>

  <div class="comment-body">
    {#if comment.comment_to_jwt_client}
      <span 
        class="parent-info" 
        on:click={() => dispatch('scroll-to-children', { comment })}
      >
        {comment.comment_to_jwt_client.first_name} 
        {comment.comment_to_jwt_client.last_name},&nbsp;
      </span>
    {/if}

    <span class="comment-text">{@html showMessage ? comment.text_web : comment.text_web.slice(0, 1000)}</span>

    {#if !showMessage && comment.text_web.length > 1000}
      {#if comment.text_web }
      <span style='color: #2B50ED; cursor: pointer;' class='span_text text-bold' on:click={() => showMessage = true}>
        <span class='text-grey'>...</span>
          {$_('ShowMore')}
        </span>
      {/if}
    {/if}
  </div>

  {#if comment.comment_images.length }
    <div class="comment-images">
      {#each comment.comment_images as image, index }
        <div 
          class="comment-image {getMobileClass()}"
          style:background={`url("${image.formatted_image_pico}") no-repeat center/contain`}
          style:width={comment.comment_images.length === 1 
            ? '181px' 
            : isMobile ? 'auto' :'113px'
          }
          style:height={comment.comment_images.length === 1 ? '120px': '75px'}
          on:click={() => {
            currentShowImage.index = index;
            currentShowImage.image = image.image;
            showModalPictere = true;
          }} 
        />
      {/each}
    </div>
  {/if}

  <!-- модальное окно для картинки -->
  <ImagePopup 
    isShow={showModalPictere}
    src={currentShowImage.image}
    currentImageIndex={currentShowImage.index}
    imagesCount={comment.comment_images.length}
    on:close="{() => showModalPictere = false}"
    on:change-image={changeImage}
  />

  <div class="comment-footer">
    <span class="date text-grey text-bold">
      <DateComponent createdDate={comment.created_at} />
    </span>

    {#if !comment.abstract_removed}
      {#if !disable_comments}
        <span 
          class="reply text-bold" 
          on:click={replyHandler}
        >
          {$_('Reply')}
        </span>
      {/if}
    
      <div style="margin-left: auto">
        <CommentLike {comment} />
      </div>
    {/if}
  </div>
</div>

{#if isShowReplyInput && $currentReplyCommentId === comment.pk}
  <ReplyInput
    {comment} 
    {isChild} 
    {id_publicate}
    on:created-comment={createdComment}
    on:hide={() => isShowReplyInput = false}
  />
{/if}

<style lang="scss">
  .curator-card {
    position: absolute;
    background-color: white;
    width: 290px;
    max-height: 206px;
    box-shadow: 0px 2px 10px 0px #30333D42;
    border-radius: 10px;
    margin-top: 14px;
    z-index: 1;
    left: 0;

    i {
      padding: 0;
      color: #FF7329;
      margin-right: 8px;
      font-size: 16px;
    }

    &-header {
      background-color: #E0E8F6;
      padding: 12px;
      border-radius: 10px 10px 0 0;
      display: grid;
      grid-template-columns: 50px auto;
      grid-gap: 10px;
      align-items: center;

      .curator-card-image {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-right: 10px;
      }

      .curator-card-title {
        font-size: 16px;
        font-weight: 600;
        line-height: 23px;
        color: #30333D;
      }
    }

    &-body {
      padding: 12px;
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: #30333D;

      .curator-card-item {
        margin-bottom: 8px;
        display: flex;
        align-items: center;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    &-footer {
      padding: 0 12px 12px 12px;
      display: flex;
      align-items: center;

      svg {
        padding-right: 29px;
        cursor: pointer;
      }
    }
  }

  i::before {
    margin: 0;
  }

  .icon-warning-fill {
    color: #FB7662;
  }

  .deleted-comment-text {
    color: #5A5F6D99;
    font-size: 16px;
    margin-left: 5px;
  }

  .comment-images {
    display: flex;
    margin-left: 42px;
    margin-top: 6px;
    margin-bottom: 6px;

    @media (max-width: 576px) {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      grid-gap: 6px;
    }
  }

  .comment-image {
    margin-right: 6px;
    border-radius: 5px;
    cursor: pointer;
    background-color: #D6D6D6 !important;
    // Убираем выделение при нажатии в моб-ых версиях
    -webkit-tap-highlight-color: transparent;

    @media (max-width: 576px) {

      &.three-span {
        &:first-child,
        &:nth-child(2) {
          grid-column: span 3;  
        }

        grid-column: span 2;
      }

      &.two-span {
        grid-column: span 3;
      }
      
      width: auto;
      height: 80px;
      margin-right: 0;
    }
  }
    
  .first-child {
    border-top: 1px solid #E0E8F6;
  }

  .parent-info {
    white-space: nowrap;
    cursor: pointer;
    color: #2B50ED;
  }

  .comment-body {
    padding-left: 40px;
    word-break: break-word;
  }

  .wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

.main{
  display: flex;
  padding: 16px 0;
  flex-direction: column;
  transition: background 0.5s;

  &.child {
    padding-left: 62px;

    @media (min-width: 320px) and (max-width: 1000px) {
      padding-left: 42px !important;
    }
  }
}

.main__info{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.main__info_client{
  display: flex;
  align-items: center;
}

.comment-footer {
  display: flex;
  align-items: center;
  padding: 0 0 0 40px;
  margin-top: 6px;
}
.block_name_user{
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
}
.name{
  display: inline;
  font-size: 16px;
  line-height: 23px;
  padding-left: 5px;
}

.image{
  border-radius: 100px;
}

.comment-text{
  font-size: 16px;
  line-height: 23px;
}

.reply {
  background-color: transparent;
  cursor: pointer;
  border:none; 
  font-size: 12px;
  line-height: 18px;
  margin-left: 5px;
  color: #2B50ED;
}

.date{
  font-size: 12px;
  line-height: 18px;
}

i{
  padding-left: 5px;
  }

/* для всплывающей подсказки */
[data-tooltip] {
  position: relative;
}

[data-tooltip]:before,
[data-tooltip]:after {
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
	transition: .2s ease-out;
	transform: translate(-50%, 5px)
}

[data-tooltip]:before {
  position: absolute;
  white-space: nowrap;
  margin-top: 20px;
  margin-left: 30px;
  padding: 12px;
  background-color: #FFFFFF;
  color: #30333D;
  content: attr(data-tooltip);
  text-align: center;
  border-radius: 10px;
  font-size: 14px;
  line-height: 20px;
  box-shadow: 0px 1px 12px rgba(48, 51, 61, 0.18);
}

[data-tooltip]:hover:before,
[data-tooltip]:hover:after {
  visibility: visible;
  opacity: 1;
	transform: translate(-50%, 0)
}

@media (max-width: 768px){
  [data-tooltip]:before {
    margin-left:60px;
  } 
}

@media (max-width: 500px){
  [data-tooltip]:before {
    transform: none !important;
    right: -20px;
    width: 130px;
    height: auto;
    white-space: break-spaces;
  } 
}
</style>

